$(".campaign_article_card, .feature_article_card, .sub-footer, .footer").hide(0)

$(".feature_article_card:first").removeClass("feature_article_card").addClass("feature_article_card_first");
$(".feature_article_card_bg:first").removeClass("feature_article_card_bg").addClass("feature_article_card_bg_first");
$(".feature_article_card_text:first").removeClass("feature_article_card_text").addClass("feature_article_card_text_first");

$(".feature_article_card:odd").css("left", "2vw");

$( document ).ready(function() {
  i = 0
  $('.campaign_article_card_title').each(function(j){
       i = i + 1;
       if (i == 2) {
              // add class
              $(this).removeClass('campaign_article_card_title').addClass('campaign_article_card_title_alt');
              i = 0;
       }
  });
  i = 0
  $('.campaign_article_card_text').each(function(j){
       i = i + 1;
       if (i == 2) {
              // add class
              $(this).removeClass('campaign_article_card_text').addClass('campaign_article_card_text_alt');
              i = 0;
       }
  });
});

if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
  $('.campaign_article_card').removeClass('eight push_four').addClass('twelve push_two');
  }



$(".campaign_article_card, .feature_article_card, .feature_article_card_first, .sub-footer, .footer").delay(500).fadeIn(1000)
